export enum EIcons {
  actions = 'actions',
  addSquare = 'addSquare',
  alerts = 'alerts',
  audit = 'audit',
  assignmentInd = 'assignmentInd',
  collapse = 'collapse',
  expand = 'expand',
  fileDownloadIn = 'fileDownloadIn',
  forensic = 'forensic',
  map = 'map',
  overview = 'overview',
  playbooks = 'playbooks',
  report = 'report',
  scan = 'scan',
  settings = 'settings',
  sspm = 'sspm',
  user = 'user',
  eye = 'eye',
  eyeOff = 'eyeOff',
  cynetLogo = 'cynetLogo',
  cynetIcon = 'cynetIcon',
  menuOpen = 'menuOpen',
  garbage = 'garbage',
  edit = 'edit',
  checkboxIndeterminate = 'checkboxIndeterminate',
  checkboxChecked = 'checkboxChecked',
  checkboxCircle = 'checkboxCircle',
  delete = 'delete',
  plus = 'plus',
  menuClose = 'menuClose',
  search = 'search',
  site = 'site',
  checkboxEmpty = 'checkboxEmpty',
  moreActions = 'moreActions',
  duplicate = 'duplicate',
  generateMSI = 'generateMSI',
  x = 'x',
  logout = 'logout',
  refresh = 'refresh',
  save = 'save',
  options = 'options',
  rightArrow = 'rightArrow',
  dot = 'dot',
  rightArrowDivider = 'rightArrowDivider',
  leftArrow = 'leftArrow',
  switch = 'switch',
  warn = 'warn',
  loadingSpinner = 'loadingSpinner',
  circle = 'circle',
  circledX = 'circledX',
  circledPartial = 'circledPartial',
  circledWarning = 'circledWarning',
  excel = 'excel',
  endpoints = 'endpoints',
  windowsLogo = 'windowsLogo',
  linuxLogo = 'linuxLogo',
  macLogo = 'macLogo',
  viewFile = 'viewFile',
  filters = 'filters',
  minus = 'minus',
  fix = 'fix',
  info = 'info',
  sendMail = 'sendMail',
  unfix = 'unfix',
  export = 'export',
  export2 = 'export2',
  download = 'download',
  import = 'import',
  import2 = 'import2',
  openInFull = 'openInFull',
  closeFullscreen = 'closeFullscreen',
  bell = 'bell',
  emailSecurity = 'emailSecurity',
  securityPosture = 'securityPosture',
  error = 'error',
  verificationError = 'verificationError',
  verificationOff = 'verificationOff',
  verificationOn = 'verificationOn',
  ignore = 'ignore',
  unignore = 'unignore',
  comment = 'comment',
  missingComment = 'missingComment',
  circleAlert = 'circleAlert',
  uninstall = 'uninstall',
  allowReinstall = 'allowReinstall',
  protected = 'protected',
  unprotected = 'unprotected',
  blockList = 'blockList',
  close = 'close',
  checkmark = 'checkmark',
  expandDoubleArrows = 'expandDoubleArrows',
  collapseDoubleArrows = 'collapseDoubleArrows',
  bottomArrow = 'bottomArrow'
}

export type TIcons = keyof typeof EIcons;
